export function setRolesLoading (state, loading = false) {
  state.rolesLoading = loading
}

export function setRoles (state, roles) {
  state.roles = roles.data
  state.rolesCurrentPage = roles.current_page
  state.rolesLastPage = roles.last_page
  state.rolesPerPage = roles.per_page
  state.rolesTotal = roles.total
}

export function setAllRoles (state, roles) {
  state.allroles = roles
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
